import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { CharacterId, Character } from '@/types'
import { CHARACTERS } from '@/types'

interface CharacterState {
  characters: Record<CharacterId, Character>

  // Actions
  addAffection: (characterId: CharacterId, amount: number) => void
  setEquippedOutfit: (characterId: CharacterId, outfitId: string | null) => void
  getCharacter: (characterId: CharacterId) => Character
  getAffectionLevel: (characterId: CharacterId) => number
}

const createInitialCharacter = (id: CharacterId): Character => ({
  ...CHARACTERS[id],
  affection: 0,
  equippedOutfitId: null,
  unlockedAt: new Date().toISOString(),
})

export const useCharacterStore = create<CharacterState>()(
  persist(
    (set, get) => ({
      characters: {
        hana: createInitialCharacter('hana'),
        yuki: createInitialCharacter('yuki'),
        momo: createInitialCharacter('momo'),
        sumire: createInitialCharacter('sumire'),
      },

      addAffection: (characterId, amount) => set((state) => ({
        characters: {
          ...state.characters,
          [characterId]: {
            ...state.characters[characterId],
            affection: state.characters[characterId].affection + amount,
          },
        },
      })),

      setEquippedOutfit: (characterId, outfitId) => set((state) => ({
        characters: {
          ...state.characters,
          [characterId]: {
            ...state.characters[characterId],
            equippedOutfitId: outfitId,
          },
        },
      })),

      getCharacter: (characterId) => get().characters[characterId],

      getAffectionLevel: (characterId) => {
        const affection = get().characters[characterId].affection
        if (affection >= 1000) return 5
        if (affection >= 600) return 4
        if (affection >= 300) return 3
        if (affection >= 100) return 2
        return 1
      },
    }),
    {
      name: 'waifudo-characters',
    }
  )
)
